<template>
    <section class="sidebarFilter">
        <p class="sidebarFilter__desc">
            {{ trans('FORM_FILTER_LOCATION_TEXT') }}
        </p>
        <p class="entity__headline entity__headline--dark margin-bottom-10">
            <label for="isoregion">
                {{ trans('FORM_SEARCH_REGIONS') }}
            </label>
        </p>
        <CustomDropdownB
            id="inlineDropdown__location"
            data-gtm="sidebarFilter__location"
            :value="selectedRegion"
            :options="isoregionsData"
            :default="isoregionsData[0]"
            element="sidebarFilter__location"
            :bordered="true"
            @changeValue="selectLocation" />
        <div
            v-if="showSearchField"
            class="sidebarFilter__countries">
            <p
                id="isocountriesTitle"
                class="entity__headline entity__headline--dark margin-top-10">
                <label
                    for="isocountries"
                    class="required">{{ trans('FORM_COUNTRIES_TERRITORIES') }}</label>
            </p>
            <SelectSearchable
                id="isocountries"
                :options="filteredCountries"
                option-id-prefix="isocountry_"
                :show-search="true"
                :show-tags="false"
                name="isocountries[]"
                :search-placeholder="trans('FORM_COUNTRY_SEARCH')"
                search-name="isocountrySearch"
                search-id="isocountrySearch"
                search-input-labelled-by="isocountriesTitle"
                @select="setSelectedCountry" />
            <div class="selectedCountries flex facetedSearch__content">
                <button
                    v-for="country in selectedCountries"
                    :key="country.value"
                    type="button"
                    :data-gtm="`sidebarPill__${ country.name }`"
                    :aria-label="trans('FORM_FILTER_LOCATION_PILL', { '{countryName}': country.name })"
                    class="facetedSearch__tag facetedSearch__tag--selected flex flex__alignItems--center"
                    @click="removeCountry(country.value)">
                    {{ country.name }}
                    <svg
                        height="16"
                        width="16"
                        aria-hidden="true"
                        class="pill__icon">
                        <use href="#iconCrossBold" />
                    </svg>
                </button>
            </div>
        </div>
    </section>
</template>

<script>
    import CustomDropdownB from './searchDropdown';
    import SelectSearchable from './selectSearchable';
    import { useGetters } from 'composables/useVuex';
    import Translator from 'tools/trans';
    import { getJsonData } from 'tools/domHelpers';
    export default {
        name: 'LocationFilter',
        components: {
            CustomDropdownB,
            SelectSearchable,
        },
        data() {
            return {
                isoregions: getJsonData('#isoregion', 'allregions'),
                regionsWithCountriesDisabled: getJsonData('#isoregion', 'countriesdisabled'),
                selectedRegion: this.isoregion,
                regionFieldDisabled: false,
                removeRegions: false,
                hideRegions: false,
                showSearchField: false,
                selectedCountries: [],
                countries: [],
                selectedCountriesIDs: [],
            };
        },
        computed: {
            filteredCountries() {
                if (parseInt(this.selectedRegion) === 0) {
                    return this.countries;
                } else {
                    return this.countries.filter(country => {
                        return country.parent === parseInt(this.selectedRegion);
                    });
                }
            },
        },
        methods: {
            trans: Translator.trans,
            async selectLocation(region) {
                this.selectedRegion = region;
                this.selectedCountriesIDs = [];
                this.$emit('selected-countries', this.selectedCountriesIDs);
                await this.setEnabledCountries();
                this.$emit('selected-region', this.getRegionObjectById(this.selectedRegion));
                this.$parent.$emit('selected-region', this.selectedRegion);
            },

            setSelectedCountry(selectedCountries) {
                this.selectedCountries = selectedCountries;
                this.selectedCountriesIDs = [];
                for (let i = 0, len = this.selectedCountries.length; i < len; i++) {
                    if (this.selectedCountries[i].checked === true) {
                        this.selectedCountriesIDs.push(parseInt(this.selectedCountries[i].value));
                    }
                }
                this.$emit('selected-countries', this.selectedCountriesIDs);
                this.$parent.$emit('selected-countries', this.selectedCountriesIDs);
            },
            getRegionObjectById(selectedOptionId) {
                for (const i in this.isoregionsData) {
                    if (Object.prototype.hasOwnProperty.call(this.isoregionsData[i], 'data') &&
                        parseInt(this.isoregionsData[i].data) === parseInt(selectedOptionId)) {

                        return this.isoregionsData[i];
                    }
                }

                return null;
            },
            regionIsCountry(region) {
                return region.idParent !== null;
            },
            setEnabledCountries() {
                this.showSearchField = true;
                const enabledCountries = this.isoregions.filter(region => {
                    if (parseInt(this.selectedRegion) > 0) {
                        return this.regionIsCountry(region) && region.idParent === parseInt(this.selectedRegion);
                    } else {
                        return this.regionIsCountry(region);
                    }
                });
                enabledCountries.sort(function(a, b) {
                    return a.displayName.localeCompare(b.displayName);
                });

                this.countries = [];
                this.countries = enabledCountries.map(country => {
                    return {
                        name: country.displayName,
                        value: parseInt(country.id),
                        checked: document.querySelector(`#region option[value="${ parseInt(country.id) }"]`).selected,
                        parent: country.idParent,
                    };
                });

                this.selectedCountries = this.countries.filter(country => country.checked);
                // disable countries if enabledCountries is empty
                if (enabledCountries.length < 1) {
                    this.showSearchField = false;
                }
            },
            removeCountry(selectedCountry) {
                const indexOfCountry = this.selectedCountriesIDs.indexOf(selectedCountry);
                this.selectedCountries[indexOfCountry].checked = false;
            },
        },
        mounted() {
            let countryList = [];
            this.setEnabledCountries();
            if (!Array.isArray(this.location) && this.location.length > 0) {
                countryList = this.location.split(',').map(function(x) {
                    return parseInt(x);
                });
            } else {
                countryList = this.location;
            }

            this.selectedCountries = [];

            for (let i = 0, len = countryList.length; i < len; i++) {
                const country = this.countries.find((country) => {
                    return country.value === countryList[i];
                });
                if (country) {
                    country.checked = true;
                } else {
                    continue;
                }
                this.selectedCountries.push(country);
            }
            this.setSelectedCountry(this.selectedCountries);
            this.$parent.$emit('excluded-regions', this.regionsWithCountriesDisabled);
        },
        setup() {
            const getters = {
                ...useGetters('search', [
                    'focus',
                    'location',
                    'regionsData',
                    'isoregion',
                    'isoregionsData',
                ]),
            };

            return {
                ...getters,
            };
        },
    };
</script>
